import { createSelector } from 'reselect'

import { FetchStatus } from '../constants/fetch_status'

export const createActionStatusesSelector = (
  stateSelector,
  initialState = {}
) =>
  createSelector(
    stateSelector,
    (state) => state.actionStatuses || initialState.actionStatuses
  )

export const createStatusForActionSelector = (actionStatusesSelector) =>
  createSelector(actionStatusesSelector, (actionStatuses) => {
    const statusForAction = {}
    Object.keys(actionStatuses).forEach((key) => {
      const { status, error, forToken = {} } = actionStatuses[key]
      statusForAction[key] = {
        isPending: status === FetchStatus.PENDING,
        isFulfilled: status === FetchStatus.FULFILLED,
        isRejected: status === FetchStatus.REJECTED,
        status,
        error,
        parsedErrors: error ? error.errors : [],
        forToken,
      }
    })
    return statusForAction
  })

export default {
  createActionStatusesSelector,
  createStatusForActionSelector,
}
